var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2231",
    "data-name": "Rectangle 2231",
    width: 18,
    height: 18,
    transform: "translate(-2 -2.026)",
    fill: "#152c40",
    stroke: "#152c40",
    strokeWidth: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10204",
    "data-name": "Group 10204",
    transform: "translate(2 2.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10203",
    "data-name": "Group 10203",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27570",
    "data-name": "Path 27570",
    d: "M6.987,0a6.987,6.987,0,1,0,6.987,6.987A6.992,6.992,0,0,0,6.987,0m0,.466A6.521,6.521,0,1,1,.466,6.987,6.516,6.516,0,0,1,6.987.466m0,.932a5.59,5.59,0,1,0,5.59,5.59A5.594,5.594,0,0,0,6.987,1.4m0,.466a5.119,5.119,0,0,1,5.036,4.192H10.6a4.388,4.388,0,0,0-3.622-1.4h0a4.361,4.361,0,0,0-3.6,1.4H1.951A5.119,5.119,0,0,1,6.987,1.863m0,3.261a4.051,4.051,0,0,1,3.263,1.237V7.967a2.514,2.514,0,0,0-2.278,2.278H6.007A2.513,2.513,0,0,0,3.731,7.967l0-1.6A4.022,4.022,0,0,1,6.982,5.124m-5.095,1.4H3.263v.932H1.887c-.014-.153-.024-.308-.024-.466s.01-.313.024-.466m5.1,0a.932.932,0,1,0,.932.932.935.935,0,0,0-.932-.932m3.724,0h1.376c.014.153.024.308.024.466s-.01.313-.024.466H10.711Zm-3.724.466a.466.466,0,1,1-.466.466.463.463,0,0,1,.466-.466m-5.036.932H3.266v.233a.233.233,0,0,0,.233.233A2.091,2.091,0,0,1,5.59,10.478a.233.233,0,0,0,.233.233h.233v1.31a5.116,5.116,0,0,1-4.1-4.1m8.76,0h1.312a5.116,5.116,0,0,1-4.1,4.1v-1.31h.233a.233.233,0,0,0,.233-.233,2.091,2.091,0,0,1,2.094-2.094.233.233,0,0,0,.233-.233Zm-4.19,2.792h.932v1.376c-.153.014-.308.024-.466.024s-.313-.01-.466-.024Z",
    fill: "#152c40",
    stroke: "#152c40",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon3);
export default __webpack_public_path__ + "static/media/social-icon3.52d43cceac206fe56ff8359c86ffbd28.svg";
export { ForwardRef as ReactComponent };